<template>
    <div class="full-screen bg-primary">
        <div class="container h-100 d-flex">
            <div class="col-12 col-md-6 offset-md-3 my-auto">
                <div class="d-flex w-100 h-100">
                    <form v-on:submit.prevent="login" class="bg-white w-100 midelivery-rounded px-200 py-150">
                        <h3 class="text-primary mb-100">Ingresar token 2FA</h3>
                        <AppInput type="number" label="Token" v-model="token"/>
                        <AppButton type="submit" class="ms-auto me-0 mt-100" variation="primary">Iniciar sesión</AppButton>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppInput from '@/components/ui/AppInput.vue';
import AppButton from '@/components/ui/AppButton.vue';
import { auth } from '@/auth';
import { useMainStore } from '@/store';
export default {
    components:{ AppInput, AppButton },
    data(){
        return {
            token:'',
        }
    },
    methods:{
        login(){
            auth().checkAuthToken(  this.$route.query.email,  this.token )
            .then( ({user})=>{
                useMainStore().login(user)
                this.$router.push('/statics')
            } )
        }
    }
}
</script>